/** Settings > Connections > QuickBooks: Intuit's launch, disconnect and reconnect address; the callback page lives under it. */
export const QUICKBOOKS_PATH = '/admin/settings/connections/quickbooks';
